import {
  AwardDisplay,
  AwardsDisplayVariants
} from 'components/common/Awards/AwardDisplay';
import { SizingOptions } from 'components/common/AwardsIcons/AwardsIcons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface SearchawardsProps {
  awards: any[];
  showAll?: boolean;
}

const SearchAward = ({ awards, showAll }: SearchawardsProps) => {
  const getPlusawardsTooltip = () => {
    let plusCerts = '+';

    // awards.forEach((award: any, index: number) => {
    //   if (index !== 0 && index !== 1) {
    plusCerts += awards.length - 1 + ` awards`;
    //   }
    // });

    return plusCerts;
  };

  return (
    <div className="search-certification">
      {awards && awards.length > 0 && (
        <>
          {showAll ? (
            awards.map((award: any, index: number) => (
              <AwardDisplay
                key={index}
                variant={AwardsDisplayVariants.ICON}
                awardValue={award.value}
                award={award}
                size={SizingOptions.SMALL}
              />
            ))
          ) : awards.length <= 1 ? (
            awards.map((award: any, index: number) => (
              <AwardDisplay
                key={index}
                variant={AwardsDisplayVariants.ICON}
                awardValue={award.value}
                award={award}
                size={SizingOptions.SMALL}
              />
            ))
          ) : (
            <>
              <AwardDisplay
                variant={AwardsDisplayVariants.ICON}
                awardValue={awards[0].value}
                award={awards[0]}
                size={SizingOptions.SMALL}
              />

              {/* <AwardsIcons awardValue={awards[0].value} />
              <AwardsIcons awardValue={awards[1].value} /> */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{getPlusawardsTooltip()}</Tooltip>}
              >
                <span className="search-certification-container search-certification-container--plus">
                  <div className="search-certification-image search-certification-image--plus">
                    +{awards.length - 1}
                  </div>
                </span>
              </OverlayTrigger>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SearchAward;
